<template>
  <div
    @click.self="close"
    class="modal fade show"
    id="exampleModalCenter"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalCenterTitle">
            Создать прием на {{ formattedDate }}
          </h5>
        </div>
        <div class="modal-body">
          <div class="doctor">
            <div class="subtitle">
              {{ doctor.department }} / {{ doctor.specialty }}
            </div>
            <div class="title">{{ doctor.name }}</div>
          </div>
          <form>
            <div class="delay">
              <div>Длительность приема: {{ duration }} мин.</div>
              <b-input-group prepend="1" append="60" class="mt-3">
                <b-form-input
                  v-model="duration"
                  type="range"
                  min="1"
                  max="60"
                ></b-form-input>
              </b-input-group>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <b-button variant="primary" @click="submit()">
            Создать
          </b-button>
          <b-button variant="outline-primary" @click="close()">
            Отменить
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  props: {
    doctor: Object,
    date: Date
  },
  computed: {
    formattedDate: function() {
      return moment(this.date).format('DD.MM.YYYY HH:mm');
    }
  },
  data: () => ({
    duration: 15
  }),
  methods: {
    async submit() {
      const offsetTime = 1000 * 60 * this.duration;
      const endDate = new Date(this.date.getTime() + offsetTime);
      const payload = {
        start_time: moment(this.date).format('YYYY-MM-DDTHH:mm:ss'),
        end_time: moment(endDate).format('YYYY-MM-DDTHH:mm:ss'),
        doctor: this.doctor.id
      };
      this.$emit('success', payload);
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.modal {
  display: block;
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.3);
}
.doctor {
  margin-bottom: 24px;
}
.doctor .title {
  font-size: 1.4rem;
  line-height: 1;
}
.doctor .subtitle {
  font-size: 0.9rem;
  color: #616161;
  font-weight: 300;
}
.input-group,
.btn-group,
.input-group > *,
.btn-group > * {
  position: static;
  z-index: auto;
}
.dates,
.days,
.time-ranges {
  margin-bottom: 12px;
}
.time-ranges .range {
  margin-top: 6px;
}
.delay {
  margin-bottom: 12px;
}
.btn-primary:focus,
.btn-outline-primary:focus {
  box-shadow: none;
}
.btn-outline-primary:hover {
  color: #007bff;
  background-color: #fff;
}
</style>
